export class UserAccessToken {
  private readonly _accessToken: string | null;

  constructor(props: { accessToken: string | null }) {
    this._accessToken = props.accessToken;
  }

  get accessToken(): string | null {
    if (!this._accessToken || this._accessToken === "") {
      return null;
    }
    return this._accessToken;
  }
}
